import { parsePhoneNumber } from "libphonenumber-js"

export default function phoneNumber(phoneNumber) {
  if (phoneNumber) {
    return parsePhoneNumber(phoneNumber, 'US').formatNational()
  } else {
    return 'None'
  }
}